import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { setVehicle } from '@/context/borrower';
import { store } from '@/context/store';

// eslint-disable-next-line no-restricted-imports
import { IVehicleReturn } from '../lookupVin/lookupVinTypes';

export async function lookupVinFromDb(partnerId: string): Promise<boolean> {
    const state = store.getState();
    const stateVin = state.borrowerReducer.vehicle.vin;
    const stateVehicle = state.borrowerReducer.vehicle;
    const disabledGlassesGuideVinLookup =
        state.displayReducer.partner.disabledGlassesGuideVinLookup;

    if (!stateVin) return false;

    if (disabledGlassesGuideVinLookup) {
        console.log('Glasses guide VIN lookup is disabled for this brand');
        return false;
    }

    const url = `/api/asset/select/${partnerId}/vinFromDb/${stateVin}`;
    try {
        const data = await postUrl<IVehicleReturn>(url, {
            billingContext: buildBillingContext(),
        });

        if (!data) return false;

        const {
            make,
            model,
            vin,
            nvic,
            variant,
            buildYear,
            glassValuation,
            description,
            bodyType,
        } = data;

        const isVehicleKnown = glassValuation ? true : false;

        store.dispatch(
            setVehicle({
                ...stateVehicle,
                make,
                model,
                nvic,
                vin,
                variant,
                buildYear,
                glassValuation,
                description,
                bodyType,
                isVehicleKnown,
            })
        );

        return isVehicleKnown;
    } catch (error) {
        console.log('Error looking up VIN from DB', error);
        return false;
    }
}
